module.exports = __webpack_public_path__ + "img/cloth_g3_hat-02.de82adf8.svg";